import {magicLinkErrorCopy} from './authErrorCopy'

/** The words of the field where the code from the sign-in mail is typed (`SignInCodeForm`). */
export type SignInCodeCopy = {
    label: string
    submit: string
    /** The same button while the code is out. */
    submitting: string
    /** The digits were checked and are not the code. */
    wrong: string
    /** There is no live code to check: used up, expired, or too many tries. */
    dead: string
}

export const DEFAULT_SIGN_IN_CODE_COPY: SignInCodeCopy = {
    label: 'Or type the 6-digit code from the email',
    submit: 'Continue',
    submitting: 'Checking…',
    wrong: 'This code is not right.',
    dead: 'This code no longer works. Use the link in the email, or send a new one.',
}

/**
 * Every word the sign-in controls (SignupGate → SignInOptions → MagicLinkForm) speak, so a product
 * that answers in several languages passes its own. A caller that passes nothing gets
 * `DEFAULT_SIGN_IN_COPY`, the English the controls always had.
 */
export type SignInCopy = {
    /** The Google button. */
    google: string
    /** The word between the Google button and the email field. */
    or: string
    /** The email field's label, read by assistive technology. */
    emailLabel: string
    /** The email form's submit button. */
    sendLink: string
    /** The same button while the request is out. */
    sending: string
    /** The line under the form when no link was asked for (the default's only sent view). */
    sent: string
    /** A `?magic-link-error=` code → its line, null for none. */
    errors: (code: string | null | undefined) => string | null
    /** The code field's words; English when omitted. */
    code?: SignInCodeCopy
    /**
     * The view a link has been sent to: replaces the form, and the Google button comes back under it as
     * the way out. Absent, the default's single line (`sent`) stands in its place.
     */
    waiting?: {
        title: string
        body: (email: string) => string
        sendAgain: string
        googleInstead: string
    }
}

export const DEFAULT_SIGN_IN_COPY: SignInCopy = {
    google: 'Sign in with Google',
    or: 'or',
    emailLabel: 'Email address',
    sendLink: 'Email me a sign-in link',
    sending: 'Sending...',
    sent: 'Check your inbox for a sign-in link.',
    errors: magicLinkErrorCopy,
}
